import { ReactNode } from 'react';
import { useHasPermission } from '../hooks/useHasPermission';

type PermissionGuardProps = {
  moduleName: string;
  permission: string;
  children: ReactNode;
  fallback?: ReactNode;
};

/**
 * PermissionGuard component is used to conditionally render children based on user permissions.
 * Usage:
 * <PermissionGuard moduleName="Cases" permission="View">
 *   <button>View Cases</button>
 * </PermissionGuard>
 */

export default function PermissionGuard({
  moduleName,
  permission,
  children,
  fallback = null,
}: PermissionGuardProps) {
  const hasPermission = useHasPermission(moduleName, permission);
  return hasPermission ? <>{children}</> : <>{fallback}</>;
}